import React, {useState, useCallback} from "react";

import debounce from 'underscore/modules/debounce.js'

function Search (props) {

    const [searchString, setSearchString] = useState('');

    const debouncedChangeHandler = useCallback(debounce((value) => props.updateSearchString(value), 500), []);

    const onChangeHandler = (value) => {

        setSearchString(value);

        debouncedChangeHandler(value);

    };

    return (

        <div className="container">
            <div className="row my-5">
                <div className="col-12">
                    <label htmlFor="">
                        Wertung nach Name filtern <small className={'text-muted'}>Mehrere Namen mit Komma  und ohne Leerzeichen trennen</small>
                    </label>
                    <div className="input-group input-group-lg">
                        <input
                            type="text"
                            className="form-control"
                            aria-label="Mädla und Buabe durchsuchen"
                            aria-describedby="inputGroup-sizing-lg"
                            value={searchString}
                            onChange={event => onChangeHandler(event.target.value)}
                        />
                        <div className="input-group-append">
                            <button className="btn btn-secondary" type="button" id="button-addon2" onClick={() => onChangeHandler('')}>☠️</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default Search;
